export const CAMPANHA = "CAMPANHA";
export const CARIMBO = "CARIMBO";